"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTabPanel = useTabPanel;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@mui/utils");
var _Tabs = require("../Tabs");
var _useCompound = require("../useCompound");
function tabPanelValueGenerator(otherTabPanelValues) {
    return otherTabPanelValues.size;
}
/**
 *
 * Demos:
 *
 * - [Tabs](https://mui.com/base-ui/react-tabs/#hooks)
 *
 * API:
 *
 * - [useTabPanel API](https://mui.com/base-ui/react-tabs/hooks-api/#use-tab-panel)
 */ function useTabPanel(parameters) {
    var valueParam = parameters.value, idParam = parameters.id, externalRef = parameters.rootRef;
    var context = (0, _Tabs.useTabsContext)();
    if (context === null) {
        throw new Error('No TabContext provided');
    }
    var selectedTabValue = context.value, getTabId = context.getTabId;
    var id = (0, _utils.unstable_useId)(idParam);
    var ref = React.useRef(null);
    var handleRef = (0, _utils.unstable_useForkRef)(ref, externalRef);
    var metadata = React.useMemo(function() {
        return {
            id: id,
            ref: ref
        };
    }, [
        id
    ]);
    var _ref = (0, _useCompound.useCompoundItem)(valueParam !== null && valueParam !== void 0 ? valueParam : tabPanelValueGenerator, metadata), value = _ref.id;
    var hidden = value !== selectedTabValue;
    var correspondingTabId = value !== undefined ? getTabId(value) : undefined;
    var getRootProps = function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return _object_spread_props(_object_spread({
            'aria-labelledby': correspondingTabId !== null && correspondingTabId !== void 0 ? correspondingTabId : undefined,
            hidden: hidden,
            id: id !== null && id !== void 0 ? id : undefined
        }, externalProps), {
            ref: handleRef
        });
    };
    return {
        hidden: hidden,
        getRootProps: getRootProps,
        rootRef: handleRef
    };
}
